import { format } from 'date-fns';
import { DATETIME_FORMAT } from '@/utils/constants';

export default {
  filters: {
    formatDateTime(val) {
      return format(val, DATETIME_FORMAT);
    },
  },
};
